<template>
    <div class="bbbb" ref="bbbb">
        <div class="leftDiv" ref="leftDiv">
            <!--在此处添加遮罩层，因为peaimage中含有iframe，不遮住的话，会影响拖动的效果-->
            <div class="maskPeaimageDiv" ref="maskPeaimageDiv"></div>
            <peaimage class="peaimageArea"></peaimage>
        </div>
        <div class="resizeDiv" title="收缩侧边栏" ref="resizeDiv">⋮</div>
        <div class="middleDiv" ref="middleDiv">
            <div :class="'theReport'">

                <div class="report">
                    <div class="reportForm">
                        <Tag class="tag2" :color="tag2.color">{{ tag2.text }}</Tag>

                        <Tag class="tag" color="green">{{ tag }}</Tag>
                        <div class="top">
                            <!-- <Button type="primary" class="btnLeft">原始报告</Button> -->
                            <!-- <Button type="error" class="btnLeft" @click="back=true" v-if="reportFlow.sendBackReasonType<=0||reportFlow.sendBackReasonType>4">退回申请</Button> -->
                            <Button @click="back = true"
                                v-if="(reportFlow.sendBackReasonType <= 0 || reportFlow.sendBackReasonType > 4) && (reportFlow.status == 0 || reportFlow.status == 2)"
                                class="btnLeft" type="warning">
                                <Icon type="ios-git-compare" size="18" />
                                <span>退回申请</span>
                            </Button>
                        </div>
                        <div class="applicantMsg">
                            <span class="title">{{ customer.title }}</span>
                            <span class="title">{{ reportFlow.deviceType }}检查</span>
                            <span>申请人：{{ reportFlow.createAccountName ? reportFlow.createAccountName : '' }}</span>
                            <span>电话：{{ reportFlow.createAccountPhone ? reportFlow.createAccountPhone : '' }}</span>
                            <span>时间：{{ createTime }}</span>
                        </div>
                        <div class="reportBody">
                            <div class="PatientInformation">
                                <strong>基本信息：</strong>
                                {{ formData.patientName }} &nbsp;
                                {{ formData.patientSex == 0 ? '男' : formData.patientSex == 1 ? '女' : '不详' }} &nbsp;
                                {{ formData.patientAge }}
                            </div>

                            <div class="PatientInformation">
                                <strong>科室：</strong>
                                {{ formData.applyOffice }}
                            </div>
                            <div class="PatientInformation">
                                <strong>门诊/住院号：</strong>
                                {{ formData.hospitalNo }}
                            </div>
                            <div class="PatientInformation">
                                <strong>床号：</strong>
                                {{ formData.bedNo }}
                            </div>
                            <div class="PatientInformation">
                                <strong>患者编号：</strong>
                                {{ formData.patientNo }}
                            </div>
                            <div class="PatientInformation">
                                <strong>检查日期：</strong>
                                {{ patientCheckTime }}
                            </div>
                            <div class="PatientInformation">
                                <strong>检查部位：</strong>
                                {{ formData.checkPoint }}
                            </div>
                            <div class="PatientInformation">
                                <strong>检查方法：</strong>
                                {{ formData.deviceType }} {{ checkMethod }}
                            </div>
                        </div>
                        <div v-if="formData.deviceType == 'MR'">
                            <label class="label" for="">MR扫描方法：</label>
                            <span>{{ formData.mrCheckMethod }}</span>
                        </div>
                        <div>
                            <div style="height:30px;">
                                <label class="label" for="">病情描述：</label>
                                <span class="selfTemplate" @click="showTemplates">
                                    <Icon size="16" style="line-height:30px" type="md-search" />
                                    调用模板
                                </span>
                            </div>
                            <p>{{ formData.describe }}</p>
                        </div>
                        <div v-if="formData.accessories">
                            <label class="label" for="">附件：</label>
                            <viewer :images="accessories">
                                <img v-for="(img, index) in accessories" class="accessories"
                                    :src="'/api/file/acquisition/' + img" :key="index">
                            </viewer>
                        </div>
                        <div>
                            <div>
                                <label class="label" for="">
                                    <span style="color:red;">*</span>
                                    影像学表现：
                                </label>
                                <span v-if="reportFlow.writeAccountName">
                                    <span class="write" v-if="">
                                                                            <Icon type="ios-clock-outline" size="20" color="#2d8cf0" />{{ writeTime }}
                                    </span>
                                    <span class="write">
                                        <Icon type="ios-clipboard-outline" size="22" color="#2d8cf0" />
                                        {{ reportFlow.writeAccountName }}
                                    </span>
                                </span>

                            </div>
                            <Input class="textarea" v-model="description" type="textarea" :autosize="autosize" :rows="6"
                                placeholder="影像学表现" />
                        </div>
                        <div>
                            <div style="height:30px;">
                                <label class="label" style="width:100%;" for="">
                                    <span style="color:red;">*</span>
                                    影像提示:
                                </label>

                                <span class="selfTemplate" @click="addOrUpdateTemplateShowUI('3')">
                                    <Icon size="16" style="line-height:30px;" type="md-archive" />
                                    保存模板
                                </span>
                            </div>
                            <Input class="textarea" v-model="contents" type="textarea" :autosize="autosize2" :rows="5"
                                placeholder="影像提示" />
                        </div>
                        <div>
                            <div style="height:30px;">
                                <label class="label" for="">建议:</label>

                            </div>
                            <Input class="textarea" v-model="suggests" type="textarea" :autosize="autosize3" :rows="2"
                                placeholder="建议" />
                        </div>
                        <div>
                            <label class="label" for="">
                                <span style="color:red;">*</span>
                                诊断结果：
                            </label>
                            <RadioGroup v-model="diagnosis">
                                <Radio :label="0">阴性</Radio>
                                <Radio :label="1">阳性</Radio>
                            </RadioGroup>
                        </div>
                        <!-- <div>
                    <label class="label" for="">加入疑难会诊：</label>
                    <i-switch size="small" v-model="reportProperty">
                    </i-switch>
                </div> -->
                        <div>
                            <label class="label" for="">危急值：</label>
                            <i-switch size="small" v-model="openCritical">
                            </i-switch>
                            <Select v-if="openCritical" v-model="danger" style="width:400px">
                                <OptionGroup v-for="(i, index) in Criticallist" :key="index" :label="i.title">
                                    <Option v-for="item in i.children" :value="item" :key="item">{{ item }}</Option>
                                </OptionGroup>
                            </Select>
                        </div>
                        <div v-if="count > 0">
                            标记影像共
                            <span class="markCount">{{ count }}</span>
                            张
                        </div>
                        <div class="btnBox">
                            <!-- v-if="reportFlow.teamMember?reportFlow.teamMember&&reportFlow.teamMember.weakPrivilege==3&&!reportFlow.isDouble&&reportFlow.status==0:true" -->
                            <Button @click="reportWriteReview" class="btnLeft"
                                :disabled="reportFlow.sendBackReasonType >= 1 && reportFlow.sendBackReasonType <= 4 ? true : false"
                                v-if="WriteReview" type="primary">
                                <Icon type="ios-clipboard" size="20" />
                                <span>完成报告</span>
                            </Button>
                            <!-- v-if="reportFlow.teamMember&&reportFlow.teamMember.weakPrivilege==3&&reportFlow.status==2" -->
                            <Button @click="reportReviewer" class="btnLeft"
                                :disabled="reportFlow.sendBackReasonType >= 1 && reportFlow.sendBackReasonType <= 4 ? true : false"
                                v-if="Reviewer" type="primary">
                                <Icon type="ios-clipboard" size="20" />
                                <span>审核通过</span>
                            </Button>
                            <!-- v-if="reportFlow.teamMember&&reportFlow.teamMember.weakPrivilege>=2&&reportFlow.status==0" -->
                            <Button @click="reportWrite" class="btnLeft"
                                :disabled="reportFlow.sendBackReasonType >= 1 && reportFlow.sendBackReasonType <= 4 ? true : false"
                                v-if="Write" type="primary">
                                <Icon type="ios-checkbox" size="20" />
                                <span>提交审核</span>
                            </Button>
                            <Button @click="fail = true"
                                :disabled="reportFlow.sendBackReasonType >= 1 && reportFlow.sendBackReasonType <= 4 ? true : false"
                                v-if="reportFlow.teamMember && reportFlow.teamMember.weakPrivilege == 3 && reportFlow.status == 2"
                                class="btnLeft" type="warning">
                                <Icon type="ios-notifications-outline" size="18" />
                                <span>审核驳回</span>
                            </Button>
                            <!-- v-if="(isAuth('review:report')||isAuth('write:report'))&&reportFlow.status!=3" -->
                            <Button @click="clickForward" class="btnRight"
                                v-if="reportFlow.teamMember && reportFlow.teamMember.weakPrivilege >= 1 && reportFlow.status != 3"
                                :disabled="reportFlow.sendBackReasonType >= 1 && reportFlow.sendBackReasonType <= 4 ? true : false"
                                type="warning">
                                <Icon type="md-swap" size="20" />
                                <span>转发</span>
                            </Button>
                            <Button @click="delClaim" class="btnRight"
                                v-if="reportFlow.reportStatus != 3 && reportFlow.reportStatus != 4 && reportFlow.teamMember"
                                :disabled="reportFlow.sendBackReasonType >= 1 && reportFlow.sendBackReasonType <= 4 ? true : false"
                                type="error">
                                <Icon type="md-power" size="18" />
                                <span>放弃任务</span>
                            </Button>
                            <Button @click="shut" class="btnRight" v-if="!reportFlow.teamMember" type="error">
                                <Icon type="md-power" size="18" />
                                <span>关闭</span>
                            </Button>
                            <Button @click="addDifficult" v-if="reportFlow.teamMember" class="btnRight" type="warning">
                                <Icon type="md-add" size="18" />
                                <span>加入疑难</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal v-model="back" title="退回申请" :loading="backReasonFormloading" @on-ok="taskBack">
            <Form ref="backForm" :model="backForm" :rules="backFormRule" :label-width="80" label-position="left">
                <FormItem label="选择原因" prop="reasonType">
                    <Select v-model="backForm.reasonType" clearable placeholder="选择退回原因">
                        <Option v-for="(item, index) in reasonTypeList" :value="index" :key="index">{{ item }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="原因说明" prop="reason">
                    <Input v-model="backForm.reason" type="textarea" placeholder="原因说明"></Input>
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="forward" :loading="loading" title="选择转发医生" width="600" @on-ok="saveForward">
            <p style="font-size:16px;margin-bottom:10px;font-weight:600;">
                转发任务不改变写报告或审报告的节点流程，请选择要转发的其他成员。
            </p>
            <p style="font-size:16px;margin-bottom:10px;font-weight:600;">
                选择医生：
                <span style="font-weight:100;color:#2d8cf0;font-family:楷体;">{{ ownerAccountName }}</span>
            </p>
            <RadioGroup type="button" v-model="ownerAccount">
                <Radio :label="i.accountId" v-for="(i, index) in doctorList" class="doctorList" :key="index">
                    <Icon size="20" v-if="ownerAccount != i.id" type="ios-disc-outline" />
                    <Icon size="20" v-if="ownerAccount == i.id" type="ios-disc" />
                    <span>{{ i.nickname }}</span>
                </Radio>
            </RadioGroup>
        </Modal>
        <Modal v-model="fail" title="审核驳回" :loading="loading" @on-ok="reviewerFail">
            <Form ref="failForm" :model="failForm" :rules="ruleValidate" :label-width="80" label-position="left">
                <FormItem label="驳回原因" prop="reason">
                    <Input v-model="failForm.reason" type="textarea" placeholder="驳回原因"></Input>
                </FormItem>
            </Form>
        </Modal>

        <!-- class-name="templateDiv" 不起作用 -->
        <Modal v-model="template" :styles="{ top: '10px', width: '800px' }" title="调用模板">
            <div>
                <report-template :deviceType="deviceType" @checkTemplate="checkTemplate"></report-template>
            </div>
            <template #footer>
                <Button type="text" @click="template = false">关闭</Button>
            </template>
        </Modal>


        <Modal v-model="updatePerTemplate" width="700" :styles="{ top: '20px' }" title="新增/修改个人模板">
            <Form ref="perTemplateForm" :model="perTemplateForm" :rules="perTemplateFormRule" :label-width="80"
                label-position="left">
                <Row>
                    <FormItem label="检查类型" prop="deviceType">
                        <RadioGroup v-model="perTemplateForm.deviceType">
                            <Radio label="x线">x线</Radio>
                            <Radio label="CT">CT</Radio>
                            <Radio label="MR">MR</Radio>
                        </RadioGroup>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="疾病分类" prop="diseaseType">
                        <Select v-if="!diseaseTypeWrite" v-model="perTemplateForm.diseaseType" style="width:300px">
                            <Option v-for="(item, index) in diseasesPerList" :value="item" :key="index">{{ item }}</Option>
                        </Select>
                        <Input v-if="diseaseTypeWrite" v-model="perTemplateForm.diseaseType" placeholder="请输入所属分类"
                            style="width: 300px" />
                        <Button type="primary" @click="diseaseTypeWrite = !diseaseTypeWrite"
                            v-html="diseaseTypeWrite ? '选择分类' : '新增分类'"></Button>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="标题" prop="title">
                        <Input v-model="perTemplateForm.title" placeholder="标题（可以采用疾病名称）"></Input>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="关键词设置" prop="diseaseName">
                        <Input v-model="diseaseName" @on-enter="addDiseaseName" placeholder="回车生成用于搜索的关键词标签"
                            style="width: 504px"></Input>
                        <Button type="info" @click="deleteDiseaseName" v-html="'清除标签'"></Button>
                        <Tag type="border" color="primary" v-for="(i, index) in diseaseNameList" :key="index">
                            {{ i }}</Tag>
                    </FormItem>
                </Row>
                <Row>
                    <!-- 注意，这里isNormal是字符串型，而报告页面的this.diagnosis是数字型，
                        二者之间的数据回显，需要转换类型-->
                    <FormItem label="阴阳性" prop="isNormal">
                        <RadioGroup v-model="perTemplateForm.isNormal">
                            <Radio label="0">阴性</Radio>
                            <Radio label="1">阳性</Radio>
                        </RadioGroup>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="征像描述" prop="description">
                        <Input v-model="perTemplateForm.description" type="textarea" :autosize="{ minRows: 4, maxRows: 6 }"
                            placeholder="影像所见/征像描述"></Input>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem label="诊断建议" prop="contents">
                        <Input v-model="perTemplateForm.contents" type="textarea" :autosize="{ minRows: 4, maxRows: 6 }"
                            placeholder="诊断建议/影像提示"></Input>
                    </FormItem>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="addOrUpdateMyTemplate">保存</Button>
                <Button style="margin-left: 8px" @click="cancelSaveTemplate">取消</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import Peaimage from '../components/Peaimage/Peaimage'
import ReportTemplate from '../components/WriteHanding/ReportTemplate'
export default {
    components: {
        Peaimage,
        ReportTemplate
    },
    data() {
        return {
            diseaseName: "",
            diseaseNameList: [],
            diseasesPerList: [],
            diseaseType: '',
            deviceType: '',
            diseaseTypeWrite: false,
            updatePerTemplate: false,
            template: false,

            perTemplateForm: {
                deviceType: "",
                diseaseName: '',
                title: "",
                isNormal: "",
                description: "",
                contents: ""
            },
            perTemplateFormRule: {
                diseaseType: [
                    { required: true, message: '疾病分类不能为空', trigger: this.diseaseTypeWrite ? 'blur' : 'change' }
                ],
                title: [
                    { required: true, message: '标题不能为空', trigger: 'blur' }
                ],
                deviceType: [
                    { required: true, message: '检查类型不能为空', trigger: 'change' }
                ],
                isNormal: [
                    { required: true, message: '阴阳性不能为空', trigger: 'change' }
                ],
                description: [
                    { required: true, message: '征像描述不能为空', trigger: 'change' }
                ],
                contents: [
                    { required: true, message: '诊断建议不能为空', trigger: 'change' }
                ]
            },

            loading: true,

            backReasonFormloading: true,
            ownerAccount: '',
            failForm: {
                reason: ""
            },
            ruleValidate: {
                reason: { type: 'string', required: true, message: '请填写驳回原因', trigger: 'blur' }
            },
            fail: false,
            forward: false,
            formData: {},
            reportProperty: false,
            autosize: {
                minRows: 6
            },
            autosize2: {
                minRows: 5
            },
            autosize3: {
                minRows: 2,
                maxRows: 2
            },
            count: 0,
            openCritical: false,
            back: false,
            backForm: {

            },
            backFormRule: {
                reasonType: { required: true, message: '选择原因', trigger: 'change' },
                reason: { required: true, message: '原因说明不能为空', trigger: 'blur' }
            },
            Criticallist: [
                {
                    title: "中枢神经系统",
                    children: [
                        "严重的颅内血肿、挫裂伤急性期。",
                        "幕上血肿≥30ml,幕下血肿≥10ml。",
                        "中线移位≥0.5cm。",
                        "广泛蛛网膜下腔出血，弥漫性脑肿胀，环池结构消失。",
                        "硬膜下血肿、硬膜外血肿急性期合并脑疝。",
                        "颅内占位性病变合并脑疝。",
                        "急性脑干出血。",
                        "脑室铸型合并急性脑积水。",
                        "颅内急性大面积脑梗死范围达到一个脑叶或全脑干范围以上。",
                        "脑出血或脑梗塞复查 CT 或 MRI 出血或梗塞程度与近期片对比明显加重。",
                        "急性重症脑炎。",
                        "急性一氧化碳或药物中毒性脑炎。"
                    ]
                },
                {
                    title: "脊柱、脊髓疾病",
                    children: [
                        "脊柱骨折伴脊柱长轴成角畸形。",
                        "椎体粉碎性骨折伴压迫硬膜囊。",
                        "寰椎、枢椎骨折、寰枢关节脱位。",
                        "急性颈椎椎体骨折并颈髓损伤。"
                    ]
                },
                {
                    title: "呼吸系统",
                    children: [
                        "气管、支气管异物。",
                        "液气胸（肺组织压缩50%以上）、尤其是张力性气胸。",
                        "肺结核浸润期及疑似结核。",
                        "重度肺毁损。"
                    ]
                },
                {
                    title: "循环系统",
                    children: [
                        "心包填塞、纵隔摆动。",
                        "急性主动脉夹层动脉瘤。",
                        "肠系膜动静脉血栓。",
                        "急性假性动脉瘤。",
                        "大的真性动脉瘤（直径大于5cm）。",
                        "急性肺动脉栓塞。"
                    ]
                },
                {
                    title: "消化系统",
                    children: [
                        "消化道穿孔。",
                        "急性肠梗阻。",
                        "急性出血坏死性胰腺炎。",
                        "急性胆道梗阻。",
                        "肝脾胰肾等腹腔脏器出血。",
                        "急性肺动脉栓塞。"
                    ]
                },
                {
                    title: "颌面五官急症",
                    children: [
                        "眼眶内异物。",
                        "眼眶及内容物破裂、骨折。",
                        "颌面部、颅底骨折。"
                    ]
                }
            ],
            danger: "",
            value: "",
            diagnosis: null,
            criticalValue: "",
            partsList: [],
            contents: "",
            description: "",
            suggests: '', //建议
            reportFlow: {},
            customer: {},
            doctorList: [],
            doctorPage: {
                page: 1,
                limit: 100,
                userType: '2'
            },
            total: 0,
            perlist: [],
            parts: []
        }
    },
    computed: {
        accessories() {
            if (this.formData.accessories) {
                return JSON.parse(this.formData.accessories)
            }
        },
        checkMethod() {
            // if (this.formData.checkMethod) {
            //     return JSON.parse(this.formData.checkMethod).join(',')
            // }
            if (this.formData.checkMethod) {
                let val = JSON.parse(this.formData.checkMethod).join(',')
                if (val && val.trim()) {
                    return "（" + val + "）"
                }
            }
            return ""
        },
        patientCheckTime() {
            return Base.dealWithTime(Number(this.formData.patientCheckTime))
        },
        createTime() {
            return Base.dealWithTime(Number(this.reportFlow.createTime))
        },
        reasonTypeList() {
            return Base.BACK_REASON2
        },
        tag() {
            let data = this.reportFlow.reportStatus
            let status
            if (data != 1) {
                status = Base.REPORT_STATUS[this.reportFlow.reportStatus]
            } else {
                if (this.reportFlow.sendBackReasonType > 1 && this.reportFlow.sendBackReasonType <= 4) {
                    status = '等待修改'
                } else {
                    if (this.reportFlow.status == 0) {
                        status = '正在写报告'
                    } else if (this.reportFlow.status == 2) {
                        status = '正在审报告'
                    }
                }
            }
            return status
        },
        tag2() {
            let patientType = this.formData.patientType
            if ('急诊' == patientType) {
                return {
                    text: '急诊',
                    color: '#F00'
                }
            } else if ('住院' == patientType) {
                return {
                    text: '住院',
                    color: '#9C2DF0'
                }
            } else {
                return {
                    text: '门诊',
                    color: '#D34E0F'
                }
            }
        },
        writeTime() {
            return Base.dealWithTime(this.reportFlow.writeTime)
        },
        ownerAccountName() {
            for (let i in this.doctorList) {
                if (this.doctorList[i].id == this.ownerAccount) {
                    return this.doctorList[i].nickname
                }
            }
        },
        doctorHidden() {
            return function (doctor) {
                let permissionList = doctor.doctorInfo.imagePermissions.split(',')
                return permissionList.includes(this.formData.deviceType)
            }
        },
        WriteReview() {
            // reportFlow.teamMember?reportFlow.teamMember&&reportFlow.teamMember.weakPrivilege==3&&!reportFlow.isDouble&&reportFlow.status==0:true
            if (this.reportFlow.reportType == "yunOffice") {
                if (this.reportFlow.status == 0) {
                    return true
                } else {
                    return false
                }
            } else {
                if (this.reportFlow.teamMember) {
                    return this.reportFlow.teamMember && this.reportFlow.teamMember.weakPrivilege == 3 && !this.reportFlow.isDouble && this.reportFlow.status == 0
                } else {
                    return true
                }
            }
        },
        Reviewer() {
            // reportFlow.teamMember&&reportFlow.teamMember.weakPrivilege==3&&reportFlow.status==2
            if (this.reportFlow.reportType == "yunOffice") {
                if (this.reportFlow.status == 2) {
                    return true
                } else {
                    return false
                }
            } else {
                if (this.reportFlow.teamMember && this.reportFlow.teamMember.weakPrivilege == 3 && this.reportFlow.status == 2) {
                    return true
                } else {
                    return false
                }
            }
        },
        Write() {
            // v-if="reportFlow.teamMember&&reportFlow.teamMember.weakPrivilege>=2&&reportFlow.status==0"
            if (this.reportFlow.reportType == "yunOffice") {
                if (this.reportFlow.status == 0) {
                    return true
                } else {
                    return false
                }
            } else {
                if (this.reportFlow.teamMember && this.reportFlow.teamMember.weakPrivilege >= 2 && this.reportFlow.status == 0) {
                    return true
                } else {
                    return false
                }
            }
        }
    },
    watch: {
        "perTemplateForm.deviceType": {
            handler: function (val) {
                this.searchdiseasesPerList()
            }
        }
    },
    methods: {
        async findByHospitalIdAndDeviceType() {
            let data = {
                deviceType: this.reportFlow.deviceType,
                hospitalId: this.reportFlow.hospitalId,
                useType: 'report'
            }
            return this.$api.form.findByHospitalIdAndDeviceType(data)
        },

        // 应用模板
        checkTemplate(value) {
            this.contents += value.contents + '\n'
            this.description += value.description + '\n'

            try {
                let isNormal = parseInt(value.isNormal)
                this.diagnosis = isNormal
            } catch (error) {
                this.diagnosis = 0
            }

            this.$Message.success("调用成功")
        },


        cancelSaveTemplate() {
            this.updatePerTemplate = false;
        },

        addDiseaseName() {
            // 添加标签
            this.diseaseNameList.push(this.diseaseName)
            // 输入框清空
            this.diseaseName = ""
        },

        deleteDiseaseName() {
            this.diseaseNameList = []
        },

        addOrUpdateTemplateShowUI(type) {
            // 新增
            if (type == '1') {

                this.$refs.perTemplateForm.resetFields();

                this.diseaseTypeWrite = false;
                this.diseaseNameList = []

                this.perTemplateForm = {
                    deviceType: this.deviceType || "",
                    diseaseType: "",
                    diseaseName: '',
                    title: "",
                    description: "",
                    contents: ""
                };

                this.searchdiseasesPerList()

                this.updatePerTemplate = true

            }
            // 在列表上点击修改
            else if (type == '2') {
                let diseaseName = this.perTemplateForm.diseaseName
                if (diseaseName && diseaseName.trim()) {
                    this.diseaseNameList = diseaseName.split(',')
                } else {
                    this.diseaseNameList = []
                }
                this.updatePerTemplate = true
            }
            // 将报告表单上的数据存为模板
            else if (type == '3') {

                this.perTemplateForm.id = ''

                let deviceType = this.formData.deviceType;

                // 除了CT和MR，其他都是X线
                if (deviceType != 'CT' && deviceType != 'MR') {
                    this.perTemplateForm.deviceType = 'x线'
                } else {
                    this.perTemplateForm.deviceType = deviceType
                }

                if (this.description) {
                    this.perTemplateForm.description = this.description
                }
                if (this.contents) {
                    this.perTemplateForm.contents = this.contents
                }

                if (this.diagnosis != null) {
                    this.perTemplateForm.isNormal = this.diagnosis + ''
                }

                this.diseaseNameList = []

                this.updatePerTemplate = true
            }
        },



        /**
         * 增加或删除个人模板
         */
        addOrUpdateMyTemplate() {
            this.$refs.perTemplateForm.validate((valid) => {
                if (valid) {
                    let data = this.perTemplateForm
                    data.diseaseName = this.diseaseNameList.join(",")
                    if (data.diseaseName == '') {
                        data.diseaseName = ' '
                    }
                    this.$api.data.addOrUpdateTemplateSelf(data).then((res) => {
                        if (res.code == 0) {
                            this.updatePerTemplate = false
                            this.deviceType = data.deviceType;
                            this.showTemplates()
                        }
                    })
                }
            })
        },

        searchdiseasesPerList() {
            let data = {
                deviceType: this.perTemplateForm.deviceType
            }
            this.$api.data.findTemplateReportDiseaseType(data).then((res) => {
                this.diseasesPerList = res.list
            })
        },


        showTemplates() {
            this.template = true
        },


        _initData() {
            let data = {
                ownerId: 0
            }
            let id = {
                reportId: window.location.href.split('?')[1].split('&')[1].split('=')[1]/////////////////////////////////////////改成影像id
            }
            this.$api.form.findByTaskId(id).then((resForm) => {
                this.formData = resForm.applicationForm
                this.customer = resForm.hospital

                if (resForm.reportFlow) {
                    this.reportFlow = resForm.reportFlow

                    let deviceType = resForm.reportFlow.deviceType
                    if (deviceType != 'CT' && deviceType != 'MR') {
                        this.deviceType = 'x线'
                    } else {
                        this.deviceType = deviceType;
                    }

                    this.description = this.reportFlow.imagingFinding || ''
                    this.contents = this.reportFlow.imagingTips || ''
                    this.diagnosis = this.reportFlow.positiveNegative
                    this.suggests = this.reportFlow.suggests
                    this.openCritical = this.reportFlow.danger ? true : false
                    this.danger = this.reportFlow.danger
                    this.reportProperty = this.reportFlow.reportProperty == "1" ? true : false

                    if (this.reportFlow.imageMark && this.reportFlow.imageMark != '{}') {
                        try {
                            let marks = JSON.parse(this.reportFlow.imageMark);
                            var markCount = 0;
                            for (var st in marks) {
                                if (marks.hasOwnProperty(st)) {
                                    var se = marks[st];
                                    for (var img in se) {
                                        if (se.hasOwnProperty(img)) {
                                            var img = se[img];
                                            for (var fm in img) {
                                                if (img.hasOwnProperty(fm)) {
                                                    markCount++; // += img[fm].length;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            this.count = markCount
                            window.CateyesPubSub.replyMarks = marks;//影像重新渲染
                        } catch (e) { }
                    }
                }
                window.CateyesPubSub.on('AFTER_CATEYES_MARK', (e, count) => {//获取标记张数
                    this.count = count
                });
            })
        },


        resizeArea() {

            var resize = this.$refs.resizeDiv
            var left = this.$refs.leftDiv
            var mid = this.$refs.middleDiv
            var box = this.$refs.bbbb
            var mask = this.$refs.maskPeaimageDiv

            mask.style.display = 'none';

            // 设置窗口拖拉的初始位置
            let lastMoveLen = window.localStorage.getItem('lastMoveLen')
            if (lastMoveLen) {
                try {
                    lastMoveLen = parseInt(lastMoveLen)
                    resize.style.left = lastMoveLen;
                    left.style.width = lastMoveLen + 'px';
                    mask.style.width = lastMoveLen + 'px';
                    mid.style.width = (box.clientWidth - lastMoveLen - 10) + 'px';
                } catch (e) { }
            }

            resize.onmousedown = function (e) {
                //颜色改变提醒
                resize.style.background = '#818181';
                var startX = e.clientX;

                resize.left = resize.offsetLeft;

                mask.style.display = '';

                // 鼠标拖动事件
                document.onmousemove = function (e) {
                    var endX = e.clientX;
                    var moveLen = resize.left + (endX - startX); // （endx-startx）=移动的距离。resize.left+移动的距离=左边区域最后的宽度
                    var maxT = box.clientWidth - resize.offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

                    if (moveLen < 32) moveLen = 32; // 左边区域的最小宽度为32px
                    if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

                    resize.style.left = moveLen; // 设置左侧区域的宽度

                    window.localStorage.setItem('lastMoveLen', moveLen)


                    left.style.width = moveLen + 'px';
                    mask.style.width = moveLen + 'px';
                    mid.style.width = (box.clientWidth - moveLen) + 'px';

                };

                document.onmouseup = function (evt) {
                    // 遮罩层隐藏
                    mask.style.display = 'none';
                    //颜色恢复
                    resize.style.background = '#d6d6d6';
                    document.onmousemove = null;
                    document.onmouseup = null;
                    resize.releaseCapture && resize.releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
                };
                resize.setCapture && resize.setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
                return false;
            };


        },

        reportWrite() {//写报告
            let a = this.diagnosis
            this.$Modal.confirm({
                loading: true,
                title: '提交审核',
                content: '请仔细核对报告，报告将提交审核，如确定无误点击确定按钮。提交后如需修改，请联系审核人驳回。',
                onOk: () => {
                    if (this.description == "") {
                        this.$Message.error('影像学表现不能为空')
                    } else if (this.contents == "") {
                        this.$Message.error('影像提示不能为空')
                    } else if (a == null) {
                        this.$Message.error('请选择阴阳性')
                    } else {
                        let data = {
                            imageMark: JSON.stringify(window.CateyesPubSub.getAllMarks()),
                            imagingFinding: this.description,//影像学表现
                            imagingTips: this.contents,//影像提示
                            positiveNegative: this.diagnosis,//阴阳性
                            suggests: this.suggests,
                            id: window.location.href.split('?')[1].split('&')[1].split('=')[1],
                            sendBackReasonType: this.reportFlow.sendBackReasonType == 0 ? 0 : 7,///流程状态改为正常
                            // reportProperty: this.reportProperty==true?'1':'0'
                        }
                        if (this.openCritical) {
                            data.danger = this.danger//危急值
                        }
                        if (this.reportFlow.sendBackReasonType == 5) {//驳回的报告再次提交审核再次回到驳回人
                            data.sendBackAccountId = this.reportFlow.sendBackAccountId
                        }

                        this.$api.form.reportWrite(data).then((res) => {
                            // this.$Message.info(res.msg)
                            this.$Modal.remove();
                            this.closeWindow('提交审核')
                        })
                    }
                }
            })

        },

        delClaim() {
            this.$Modal.confirm({
                loading: true,
                title: '放弃',
                content: '放弃此报告，将解除锁定状态，重新回到申请列表，其他医生可以继续领取任务。',
                onOk: () => {
                    let data = {
                        reportId: this.reportFlow.id,
                        reportStatus: this.reportFlow.status
                    }
                    this.$api.form.delClaim(data).then((res) => {
                        // this.$Message.info(res.msg)
                        this.$Modal.remove();
                        this.closeWindow('')
                    })
                }
            })
        },

        shut() {//关闭页面
            this.$Modal.confirm({
                title: '关闭页面',
                content: '确认关闭页面？',
                onOk: () => {
                    this.closeWindow('')
                }
            })
        },

        reportReviewer() {//审核通过
            let a = this.diagnosis
            this.$Modal.confirm({
                loading: true,
                title: '审核通过',
                content: '请仔细核对无误后点击确认按钮，报告将提交医院进行下一步打印，如需修改报告，请及时联系医院工作人员。',
                onOk: () => {
                    if (this.description == "") {
                        this.$Message.error('影像学表现不能为空')
                    } else if (this.contents == "") {
                        this.$Message.error('影像提示不能为空')
                    } else if (a == null) {
                        this.$Message.error('请选择阴阳性')
                    } else {
                        let data = {
                            imageMark: JSON.stringify(window.CateyesPubSub.getAllMarks()),
                            imagingFinding: this.description,
                            imagingTips: this.contents,
                            positiveNegative: this.diagnosis,//阴阳性
                            suggests: this.suggests,
                            id: this.reportFlow.id,
                            sendBackReasonType: this.reportFlow.sendBackReasonType == 0 ? 0 : 7,///流程状态改为正常
                            createAccountId: this.reportFlow.createAccountId
                            // sendBackReasonType:'0'///流程状态改为正常
                        }
                        if (this.openCritical) {
                            data.danger = this.danger
                        }
                        this.$api.form.reportReviewer(data).then((res) => {
                            this.$Message.info(res.msg)
                            return this.findByHospitalIdAndDeviceType()
                        }).then(res => {
                            if (res.code == 0 && res.data.createType == 1) {
                                let data = {
                                    reportId: this.reportFlow.id,
                                    userId: JSON.parse(window.sessionStorage.getItem('user')).id
                                }
                                return this.$api.form.createQrReport(data)
                            }
                        }).then(res => {
                            this.$Modal.remove();
                            this.closeWindow('审核通过')
                        })
                    }
                }
            })

        },

        reportWriteReview() {//写审一次通过
            let a = this.diagnosis
            this.$Modal.confirm({
                loading: true,
                title: '报告完成',
                content: '请确定本例报告不需要进行审核，采取单签完成，如果完成后需要修改，请及时联系医院人员。',
                onOk: () => {
                    if (this.description == "") {
                        this.$Message.error('影像学表现不能为空')
                    } else if (this.contents == "") {
                        this.$Message.error('影像提示不能为空')
                    } else if (a == null) {
                        this.$Message.error('请选择阴阳性')
                    } else {
                        let data = {
                            imageMark: JSON.stringify(window.CateyesPubSub.getAllMarks()),
                            imagingFinding: this.description,
                            imagingTips: this.contents,
                            positiveNegative: this.diagnosis,//阴阳性
                            suggests: this.suggests,
                            id: this.reportFlow.id,
                            sendBackReasonType: this.reportFlow.sendBackReasonType == 0 ? 0 : 7,///流程状态改为正常
                            createAccountId: this.reportFlow.createAccountId
                            // sendBackReasonType:'0'//流程状态改为正常
                        }
                        if (this.openCritical) {
                            data.danger = this.danger
                        }

                        this.$api.form.reportWriteReview(data).then((res) => {
                            this.$Message.info(res.msg)
                            return this.findByHospitalIdAndDeviceType()
                        }).then(res => {
                            if (res.code == 0 && res.data.createType == 1) {
                                let data = {
                                    reportId: this.reportFlow.id,
                                    userId: JSON.parse(window.sessionStorage.getItem('user')).id
                                }
                                return this.$api.form.createQrReport(data)
                            }
                        }).then(res => {
                            this.$Modal.remove();
                            this.closeWindow('审核通过')
                        })
                    }
                },
                onCancel: () => {

                }
            });
        },
        taskBack() {
            this.$refs.backForm.validate((valid) => {
                if (valid) {
                    let data = {
                        id: window.location.href.split('?')[1].split('&')[1].split('=')[1],
                        sendBackReasonType: this.backForm.reasonType,
                        sendBackReason: this.backForm.reason,

                        imageMark: JSON.stringify(window.CateyesPubSub.getAllMarks()),
                        imagingFinding: this.description,//影像学表现
                        imagingTips: this.contents,//影像提示
                        positiveNegative: this.diagnosis,//阴阳性
                        suggests: this.suggests,//建议
                        // reportProperty: this.reportProperty==true?'1':'0'//疑难会诊
                        applicationFormId: this.formData.id
                    }
                    if (this.openCritical) {
                        data.danger = this.danger//危急值
                    }
                    this.$api.form.taskBack(data).then((res) => {
                        this.back = false
                        this.closeWindow('退回')
                    })
                } else {
                    this.backReasonFormloading = false
                    let time = setTimeout(() => {
                        this.backReasonFormloading = true
                    })
                    clearTimeOut(time)
                }
            })

        },
        reviewerFail(name) {
            this.$refs.failForm.validate((valid) => {
                if (valid) {
                    let data = {
                        id: window.location.href.split('?')[1].split('&')[1].split('=')[1],
                        sendBackReasonType: 5,
                        sendBackReason: this.failForm.reason,

                        imageMark: JSON.stringify(window.CateyesPubSub.getAllMarks()),//驳回加信息
                        imagingFinding: this.description,//影像学表现
                        imagingTips: this.contents,//影像提示
                        positiveNegative: this.diagnosis,//阴阳性
                        suggests: this.suggests,//建议
                        // reportProperty: this.reportProperty==true?'1':'0'//疑难会诊
                    }
                    if (this.openCritical) {
                        data.danger = this.danger//危急值
                    }
                    this.$api.form.reviewerFail(data).then((res) => {
                        this.fail = false
                        this.closeWindow('')
                    })
                } else {
                    this.$Message.error("请填写驳回原因")
                    this.loading = false
                    let time = setTimeout(() => {
                        this.loading = true
                    })
                    clearTimeOut(time)
                }
            })
        },
        closeWindow(data) {
            this.$Message.info(data + '操作完成, 关闭页面')
            setTimeout(() => {
                window.opener.postMessage('closeWriteHanding', "*")
                window.close();
            }, 1000)
        },
        saveForward() {//保存并转发
            if (this.ownerAccount) {
                let data = {
                    ownerAccountId: this.ownerAccount,
                    id: window.location.href.split('?')[1].split('&')[1].split('=')[1],

                    imageMark: JSON.stringify(window.CateyesPubSub.getAllMarks()),
                    imagingFinding: this.description,//影像学表现
                    imagingTips: this.contents,//影像提示
                    positiveNegative: this.diagnosis,//阴阳性
                    suggests: this.suggests,//建议
                    // reportProperty: this.reportProperty==true?'1':'0'//疑难会诊
                }
                this.$api.form.saveForward(data).then((res) => {
                    this.forward = false
                    this.closeWindow('')
                })
            } else {
                this.$Message.info('请选择转发医生')
                this.loading = false
                setTimeout(() => {
                    this.loading = true
                })
            }
        },
        clickForward() {
            // let data= this.doctorPage
            let data = {
                teamId: this.reportFlow.expertId,
                weakPrivileges: []
            }
            if (this.reportFlow.status == 0) {
                data.weakPrivileges = [2, 3]
            } else if (this.reportFlow.status == 2) {
                data.weakPrivileges = [3]
            }

            this.$api.doctor.selectDoctor(data).then((res) => {
                this.doctorList = res.data
                this.doctorList.forEach(item => {
                    this.$set(item, 'tag', false)
                })
                this.forward = true
            })
        },


        addDifficult() {
            this.$Modal.confirm({
                title: '疑难',
                content: '是否加入疑难讨论？',
                onOk: () => {
                    let data = {
                        applicationFormId: this.formData.id,
                        teamId: this.reportFlow.teamMember.teamId,
                        imageId: this.reportFlow.imageId,
                        isOpen: "1",
                        reportId: this.reportFlow.id
                    }
                    this.$api.form.addDifficult(data).then(res => {
                        if (res.code == 0) {
                            let markData = {
                                reportId: this.reportFlow.id
                            }
                            this.$api.form.markDoubt(markData).then(res => {
                                
                                this.$Modal.info({
                                    title: "提示",
                                    content: "影像加入疑难讨论成功！可在疑难会诊模块参与讨论内容。"
                                });
                            })
                        } else {
                            this.$Message.info(res.msg)
                        }
                    })
                }
            })

        }
    },

    mounted() {
        this.resizeArea();
        this._initData()
    }
}
</script>

<style lang="scss" scoped>
.bbbb {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    display: flex;

    .leftDiv {
        width: 70%;
        /*左侧初始化宽度*/
        height: 100%;
        background: #FFFFFF;
        float: left;

        .maskPeaimageDiv {
            width: 70%;
            height: 100%;
            position: absolute;
            z-index: 1111;
            filter: alpha(opacity=0);
            opacity: 0;
            background: transparent;
            margin-top: 30px;
            // border: 3px red dotted;
        }

        .peaimageArea {
            position: relative;
            width: 100%;
            z-index: 1;
        }
    }

    .resizeDiv {
        cursor: col-resize;
        float: left;
        position: relative;
        top: 45%;
        background-color: #d6d6d6;
        border-radius: 5px;
        margin-top: -10px;
        width: 10px;
        height: 50px;
        background-size: cover;
        background-position: center;
        /*z-index: 99999;*/
        font-size: 32px;
        color: white;

    }

    .resizeDiv:hover {
        color: #444444;
    }

    .middleDiv {
        float: left;
        width: 30%;
        height: 100%;
        background: #fff;
        box-shadow: -1px 4px 5px 3px rgba(0, 0, 0, 0.11);
        position: relative;
    }


}


.theReport {
    height: 100%;
    width: 100%;
    // max-width: 90%;
    position: relative;
    right: 0;
    top: 0;
    display: flex;

    .report {
        margin-left: 4px;
        background: white;
        // background: pink;
        flex: 1;

        .reportForm {
            width: 100%;
            height: 100%;
            background: white;
            float: left;
            padding: 20px 20px;
            position: relative;
            overflow-y: auto;

            .tag {
                position: absolute;
                right: 10px;
                top: 25px;
            }

            .tag2 {
                position: absolute;
                right: 90px;
                top: 25px;
            }

            .applicantMsg {
                .title {
                    font-size: 20px;
                    text-align: center;
                    line-height: 36px;
                }

                span {
                    font-size: 16px;
                    margin-right: 15px;
                }
            }

            .top {
                height: 50px;

                .btnLeft {
                    float: left;
                    margin-right: 10px;
                }

                .btnRight {
                    float: right;
                }
            }

            .reportBody {
                // display: flex;
                overflow: hidden;
                border-top: 1px solid #dddddd;
                border-bottom: 1px solid #dddddd;
                padding-bottom: 10px;
                padding-top: 10px;

                .PatientInformation {
                    float: left;
                    width: 220px;
                    font-size: 14px;
                }
            }

            .accessories {
                width: 100px;
                margin-right: 2px;
            }

            .savemoban {
                overflow: hidden;
                margin-top: 10px;
            }

            .markCount {
                color: red;
            }

            .label {
                font-size: 14px;
                line-height: 34px;
                font-weight: 600;
            }

            .selfTemplate {
                cursor: pointer;
                font-size: 8px;
                float: right;
                line-height: 30px;
                color: #19be6b;

                &:hover {
                    color: #81bd6c;
                }
            }

            .write {
                float: right;
                line-height: 34px;
                margin-left: 20px;
            }

            .btnBox {
                margin-top: 5px;
                border-top: 1px solid #dddddd;
                padding-top: 20px;
            }
        }


    }
}


.doctorList {
    width: 189px;
    margin-right: 0;
}

.pageBox {
    padding-top: 10px;
    overflow: hidden;

    .page {
        float: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/WriteHandling.vue